import React, { useState, useRef } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Typography,
  Box,
  CircularProgress,
  Alert,
  Tabs,
  Tab,
  Stack,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider
} from "@mui/material";
import {
  Close, PersonAdd, UploadFile, Download, CloudUpload, CheckCircle, Error as ErrorIcon
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { KECAMATAN, getDesaByKecamatan } from "./datarecap/constants";

export const ModalCreateAkun = ({ isOpen, toggle, onUserCreated, userRole: propUserRole }) => {
  const reduxRole = useSelector((s) => s.authAdmin?.user?.role);
  const userRole = propUserRole || reduxRole || '';
  const [tab, setTab] = useState(0);
  const [userData, setUserData] = useState({
    username: "",
    email: "",
    password: "",
    role: "",
    NoWa: "",
    kecamatan: "",
    kecamatanList: [],
    desaKelurahan: "",
    nip: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [excelResult, setExcelResult] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const fileInputRef = useRef(null);

  const isAdmin = userRole === 'admin';
  const isTFL = userRole === 'TFL';

  const ROLE_OPTIONS = isAdmin
    ? [
        { value: "admin", label: "Admin" },
        { value: "surveyor", label: "Surveyor" },
        { value: "verifikator", label: "Verifikator" },
        { value: "inputdata", label: "Input Data" },
        { value: "kepaladinas", label: "Kepala Dinas" },
        { value: "ppk", label: "PPK" },
        { value: "AGR", label: "AGR" },
        { value: "TFL", label: "TFL" },
        { value: "Koordinator TFL", label: "Koordinator TFL" },
        { value: "Supplier Penyedia", label: "Supplier Penyedia" },
        { value: "penerimabantuan", label: "Penerima Bantuan" },
        { value: "Kadis", label: "Kadis" },
        { value: "Bupati", label: "Bupati" },
      ]
    : isTFL
      ? [
          { value: "AGR", label: "AGR" },
          { value: "TFL", label: "TFL" },
          { value: "Supplier Penyedia", label: "Supplier Penyedia" },
          { value: "penerimabantuan", label: "Penerima Bantuan" },
        ]
      : [];

  const isKoordTfl = userData.role === 'Koordinator TFL';
  const isAgr = userData.role === 'AGR';
  const waRequired = ['TFL', 'AGR', 'Supplier Penyedia', 'Koordinator TFL'].includes(userData.role);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'kecamatan') {
      // Reset desa saat kecamatan berubah
      setUserData({ ...userData, kecamatan: value, desaKelurahan: "" });
      return;
    }
    if (name === 'role') {
      // Reset lokasi saat role berubah
      setUserData({ ...userData, role: value, kecamatan: "", kecamatanList: [], desaKelurahan: "" });
      return;
    }    setUserData({ ...userData, [name]: value });
  };

  const toggleKecamatan = (k) => {
    setUserData((p) => ({
      ...p,
      kecamatanList: p.kecamatanList.includes(k)
        ? p.kecamatanList.filter((x) => x !== k)
        : [...p.kecamatanList, k],
    }));
  };

  const handleClose = () => {
    setError(null);
    setExcelFile(null);
    setExcelResult(null);
    setTab(0);
    setUserData({ username: "", email: "", password: "", role: "", NoWa: "", kecamatan: "", kecamatanList: [], desaKelurahan: "", nip: "" });
    toggle();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isKoordTfl && userData.kecamatanList.length === 0) {
      setError("Minimal 1 kecamatan wajib dipilih untuk Koordinator TFL");
      return;
    }
    if (isAgr && !userData.kecamatan) {
      setError("Kecamatan wajib dipilih untuk AGR (Peliuk)");
      return;
    }
    if (isAgr && !userData.desaKelurahan) {
      setError("Desa/Kelurahan wajib dipilih untuk AGR (Peliuk)");
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const payload = { ...userData };
      if (isKoordTfl) {
        // Kecamatan utama = yang dipilih, atau pertama dari list
        payload.kecamatan = userData.kecamatan || (userData.kecamatanList[0] || '');
        payload.kecamatanList = userData.kecamatanList.length
          ? JSON.stringify(userData.kecamatanList)
          : undefined;
      }
      if (!payload.kecamatan) delete payload.kecamatan;
      if (!payload.desaKelurahan) delete payload.desaKelurahan;
      if (payload.kecamatanList === undefined) delete payload.kecamatanList;
      await axios.post(`${process.env.REACT_APP_URL}/createuser`, payload, {
        withCredentials: true,
      });

      setUserData({ username: "", email: "", password: "", role: "", NoWa: "", kecamatan: "", kecamatanList: [], desaKelurahan: "", nip: "" });
      handleClose();
      onUserCreated();
    } catch (err) {
      setError(err.response?.data?.msg || err.response?.data?.message || "Terjadi kesalahan saat membuat pengguna baru");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadTemplate = async () => {
    setDownloading(true);
    setError(null);
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL}/users/template`, {
        withCredentials: true,
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'template_create_user.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err.response?.data?.msg || 'Gagal mengunduh template');
    } finally {
      setDownloading(false);
    }
  };

  const handleExcelSelect = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!/\.(xlsx|xls)$/i.test(f.name)) {
      setError('Hanya file Excel (.xlsx / .xls) yang diperbolehkan');
      return;
    }
    setExcelFile(f);
    setExcelResult(null);
    setError(null);
  };

  const handleExcelUpload = async () => {
    if (!excelFile) {
      setError('Pilih file Excel terlebih dahulu');
      return;
    }
    setLoading(true);
    setError(null);
    setExcelResult(null);
    try {
      const fd = new FormData();
      fd.append('file', excelFile);
      const res = await axios.post(`${process.env.REACT_APP_URL}/users/bulk`, fd, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setExcelResult(res.data);
      if (res.data.successCount > 0) {
        onUserCreated();
      }
    } catch (err) {
      setError(err.response?.data?.msg || err.message || 'Gagal upload Excel');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        m: 0, p: 2, backgroundColor: '#f9fafc'
      }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" display="flex" alignItems="center">
            <PersonAdd sx={{ mr: 1 }} />
            Tambah Pengguna
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <Close fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
        <Tabs value={tab} onChange={(_, v) => { setTab(v); setError(null); }}>
          <Tab icon={<PersonAdd fontSize="small" />} iconPosition="start" label="Satu Akun" />
          <Tab icon={<UploadFile fontSize="small" />} iconPosition="start" label="Upload Excel" />
        </Tabs>
      </Box>

      {tab === 0 && (
        <form onSubmit={handleSubmit}>
          <DialogContent dividers>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
            )}

            <TextField
              margin="normal" required fullWidth label="Username" name="username"
              autoComplete="username" value={userData.username} onChange={handleChange} autoFocus
            />
            <TextField
              margin="normal" required fullWidth label="Email" name="email" type="email"
              autoComplete="email" value={userData.email} onChange={handleChange}
            />
            <TextField
              margin="normal" required fullWidth label="Password" name="password" type="password"
              autoComplete="new-password" value={userData.password} onChange={handleChange}
            />
            <TextField
              margin="normal" required={waRequired} fullWidth label="Nomor WhatsApp" name="NoWa"
              value={userData.NoWa} onChange={handleChange}
              helperText="Wajib untuk role TFL, AGR, Koordinator TFL, dan Supplier Penyedia"
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Role</InputLabel>
              <Select name="role" value={userData.role} onChange={handleChange} label="Role">
                {ROLE_OPTIONS.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                ))}
              </Select>
              {isTFL && (
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                  Sebagai TFL, Anda hanya dapat membuat akun AGR, TFL, Supplier, dan Penerima Bantuan.
                </Typography>
              )}
            </FormControl>
            {userData.role === 'PPK' && (
              <TextField
                margin="normal"
                fullWidth
                label="NIP"
                name="nip"
                value={userData.nip}
                onChange={handleChange}
                helperText="NIP khusus role PPK, tampil pada format Laporan Penggunaan Dana."
              />
            )}
            {isKoordTfl && (
              <FormControl fullWidth margin="normal" required>
                <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                  Kecamatan Wilayah Pantau (bisa lebih dari 1, wajib)
                </Typography>
                <Box sx={{
                  border: '1px solid rgba(0,0,0,0.23)',
                  borderRadius: 1,
                  p: 1,
                  maxHeight: 200,
                  overflowY: 'auto'
                }}>
                  {KECAMATAN.map((k) => {
                    const checked = userData.kecamatanList.includes(k);
                    return (
                      <Box key={k} display="flex" alignItems="center" gap={1} sx={{ py: 0.25, cursor: 'pointer' }} onClick={() => toggleKecamatan(k)}>
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => toggleKecamatan(k)}
                          style={{ cursor: 'pointer' }}
                        />
                        <Typography variant="body2" sx={{ cursor: 'pointer' }}>{k}</Typography>
                      </Box>
                    );
                  })}
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                  Koordinator TFL akan memantau & memverifikasi bantuan di kecamatan-kecamatan ini.
                </Typography>
              </FormControl>
            )}
            {isAgr && (
              <>
                <FormControl fullWidth margin="normal" required>
                  <InputLabel>Kecamatan Wilayah AGR</InputLabel>
                  <Select name="kecamatan" value={userData.kecamatan} onChange={handleChange} label="Kecamatan Wilayah AGR">
                    {KECAMATAN.map((k) => (
                      <MenuItem key={k} value={k}>{k}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth margin="normal" required disabled={!userData.kecamatan}>
                  <InputLabel>Desa/Kelurahan Wilayah AGR</InputLabel>
                  <Select name="desaKelurahan" value={userData.desaKelurahan} onChange={handleChange} label="Desa/Kelurahan Wilayah AGR">
                    {getDesaByKecamatan(userData.kecamatan).map((d) => (
                      <MenuItem key={d} value={d}>{d}</MenuItem>
                    ))}
                  </Select>
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                    AGR (Peliuk) akan difilter berdasarkan kecamatan & desa/kelurahan saat penunjukan pada data bantuan.
                  </Typography>
                </FormControl>
              </>
            )}
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
            <Button onClick={handleClose} variant="outlined">Batal</Button>
            <Button
              type="submit" variant="contained" color="primary" disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <PersonAdd />}
            >
              {loading ? 'Menyimpan...' : 'Tambah Pengguna'}
            </Button>
          </DialogActions>
        </form>
      )}

      {tab === 1 && (
        <>
          <DialogContent dividers>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
            )}

            <Alert severity="info" sx={{ mb: 2 }}>
              Unduh template Excel, isi data user (hapus baris contoh), lalu unggah kembali.
              Kolom wajib: <strong>username, email, password, role</strong>.
              NoWa wajib untuk TFL/AGR/Koordinator TFL/Supplier. Kecamatan wajib untuk Koordinator TFL.
              Kecamatan & desaKelurahan disarankan untuk AGR (Peliuk) agar bisa difilter per wilayah.
            </Alert>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mb: 2 }}>
              <Button
                variant="outlined"
                startIcon={downloading ? <CircularProgress size={18} /> : <Download />}
                onClick={handleDownloadTemplate}
                disabled={downloading}
              >
                Unduh Template Excel
              </Button>
              <Button
                variant="outlined"
                component="label"
                startIcon={<CloudUpload />}
              >
                {excelFile ? excelFile.name : 'Pilih File Excel'}
                <input
                  ref={fileInputRef}
                  type="file"
                  hidden
                  accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                  onChange={handleExcelSelect}
                />
              </Button>
            </Stack>

            {excelFile && (
              <Paper variant="outlined" sx={{ p: 1.5, mb: 2, bgcolor: '#f5f7fa' }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="body2">
                    File: <strong>{excelFile.name}</strong> ({(excelFile.size / 1024).toFixed(1)} KB)
                  </Typography>
                  <Button size="small" color="error" onClick={() => { setExcelFile(null); setExcelResult(null); if (fileInputRef.current) fileInputRef.current.value = ''; }}>
                    Hapus
                  </Button>
                </Stack>
              </Paper>
            )}

            {excelResult && (
              <Box sx={{ mt: 1 }}>
                <Stack direction="row" spacing={1} sx={{ mb: 1.5 }} flexWrap="wrap" useFlexGap>
                  <Chip
                    icon={<CheckCircle />}
                    color="success"
                    label={`${excelResult.successCount || 0} berhasil`}
                  />
                  <Chip
                    icon={<ErrorIcon />}
                    color={excelResult.failedCount > 0 ? 'error' : 'default'}
                    label={`${excelResult.failedCount || 0} gagal`}
                  />
                </Stack>

                {excelResult.success?.length > 0 && (
                  <>
                    <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>Berhasil dibuat</Typography>
                    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 180, mb: 2 }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell>Baris</TableCell>
                            <TableCell>Username</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Role</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {excelResult.success.map((r, i) => (
                            <TableRow key={i}>
                              <TableCell>{r.row}</TableCell>
                              <TableCell>{r.username}</TableCell>
                              <TableCell>{r.email}</TableCell>
                              <TableCell>{r.role}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                )}

                {excelResult.failed?.length > 0 && (
                  <>
                    <Typography variant="subtitle2" fontWeight={600} color="error" sx={{ mb: 0.5 }}>Gagal</Typography>
                    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 200 }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell>Baris</TableCell>
                            <TableCell>Username</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Error</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {excelResult.failed.map((r, i) => (
                            <TableRow key={i}>
                              <TableCell>{r.row}</TableCell>
                              <TableCell>{r.username}</TableCell>
                              <TableCell>{r.email}</TableCell>
                              <TableCell sx={{ color: 'error.main', fontSize: 12 }}>{r.error}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                )}
              </Box>
            )}

            <Divider sx={{ my: 2 }} />
            <Typography variant="caption" color="text.secondary" component="div">
              Role yang diizinkan: {ROLE_OPTIONS.map((r) => r.label).join(', ')}.
              Baris contoh (username diawali &quot;contoh_&quot;) diabaikan otomatis.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
            <Button onClick={handleClose} variant="outlined">Tutup</Button>
            <Button
              variant="contained"
              color="primary"
              disabled={loading || !excelFile}
              onClick={handleExcelUpload}
              startIcon={loading ? <CircularProgress size={20} /> : <UploadFile />}
            >
              {loading ? 'Mengunggah...' : 'Upload & Buat Akun'}
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ModalCreateAkun;
